import React from "react";
import { UserRole } from "../../../global-query-types";
import { SignupContainer } from "../../../auth/components/Signup/SignupContainer";

const ClientSignUpScene = () => {
  return <SignupContainer asUser={UserRole.Client} />;
};

export default ClientSignUpScene;
